<template>
  <div class="row">
    <div class="col-lg-5 col-lg-offset-1">
      <div class="hpanel">
        <div class="panel-heading">
          Add Page Type
        </div>
        <div class="panel-body">
          <form class="form-horizontal" @submit.prevent="postPageType()">
            <div class="row">
              <div class="form-group col-md-10" style="margin-left: 5%">
                <label class="control-label">Name</label>

                <div class=""><input v-model="page.name" type="text" placeholder="Membership Type Name..." class="form-control"></div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-10" style="margin-left: 5%">
                <label class="control-label">Description</label>

                <div class="">
                  <textarea v-model="page.description" id="" cols="30" rows="10" class="form-control"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-8 col-sm-offset-1">
                <button class="btn btn-primary" type="submit">Add</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-lg-5">
      <div class="hpanel">
        <div class="panel-heading">
          PageTypes
        </div>
        <div class="panel-body">
          <div class="table-responsive">
            <vue-good-table
              :columns="columns"
              :rows="allPageTypes"
              :paginate="true"
              :globalSearch="true"
              :lineNumbers="true"
              styleClass="table table-responsive table-bordered table-stripped"
              :loading="$loadingTrue"
            >
              <template slot="table-row" slot-scope="props">
                <td class="fancy">{{ props.row.name}}</td>
                <td class="fancy">{{ props.row.description}}</td>
                <td class="has-text-right">
                  <button class="btn btn-sm btn-warning" @click="deleteMembershipType(props.row.public_id)">Disable</button>
                </td>
              </template>
            </vue-good-table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-types',
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Description',
          field: 'description'
        },
        {
          label: 'Action',
          value: ''
        }
      ],
      page: {
        name: '',
        description: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_page_types')
  }
}
</script>

<style scoped>

</style>
